import isHotkey from 'is-hotkey';

export const isMacOS = () => window.navigator.userAgent.indexOf("Mac") !== -1;

export const shouldSkipKeyboardEvent = (event, editor, isSlateEditor) => {
  // Skip if there's a save error
  if (editor.props.transcript.saveError) {
    return true;
  }

  // Skip if we're in slate editor and it has focus
  if (isSlateEditor && editor.hasFocus) {
    return true;
  }

  return false;
};

export const handleBackspaceNavigation = (event, isSlateEditor, editor) => {
  if (
    event.code === "Backspace" &&
    (event.target || event.srcElement).tagName !== "TEXTAREA" &&
    (event.target || event.srcElement).tagName !== "INPUT" &&
    (!isSlateEditor || !editor.hasFocus)
  ) {
    event.preventDefault();
  }
};

export const handleTabKey = (event, onAudioToggle) => {
  if (
    !event.ctrlKey &&
    !event.altKey &&
    !event.shiftKey &&
    !event.metaKey &&
    event.key === "Tab"
  ) {
    event.preventDefault();
    onAudioToggle();
  }
};

export const handleControlKeys = (event, { onAudioToggle, onRewind, onChangeSpellCheckFeatureStatus }, isSlateEditor) => {
  if (isHotkey("Control+space", event)) {
    event.preventDefault();
    onAudioToggle();
  } else if (isHotkey("Control+r", event)) {
    event.preventDefault();
    onRewind();
  } else if (isSlateEditor && isHotkey("Control+g", event)) {
    event.preventDefault();
    onChangeSpellCheckFeatureStatus();
  }
};

export const handleArrowKeys = (event, { onRewind, onForward }) => {
  if (!event.ctrlKey && event.altKey && !event.shiftKey && !event.metaKey) {
    if (event.key === "ArrowLeft") {
      event.preventDefault();
      onRewind();
    } else if (event.key === "ArrowRight") {
      event.preventDefault();
      onForward();
    }
  }
};

const shouldSkipUndoRedoForDialog = (event, isRatingDialogOpen) => {
  if (!isRatingDialogOpen) {
    return false;
  }

  const activeElement = event.target || document.activeElement;
  const tagName = activeElement?.tagName;
  if (tagName === "INPUT" || tagName === "TEXTAREA") {
    const dialog = activeElement?.closest?.('[role="dialog"]');
    if (dialog) {
      return true;
    }
  }
  return false;
};

const handleMacUndoRedo = (event, { onUndo, onRedo }) => {
  if (!isMacOS() || event.ctrlKey || !event.metaKey) {
    return false;
  }

  if (!event.shiftKey && event.key === "z") {
    event.preventDefault();
    onUndo();
    return true;
  }

  if (event.shiftKey && event.keyCode === 90) {
    event.preventDefault();
    onRedo();
    return true;
  }

  return false;
};

const handleWindowsUndoRedo = (event, { onUndo, onRedo }) => {
  if (!event.ctrlKey) {
    return false;
  }

  if ((event.keyCode === 90 && event.shiftKey) || event.key === "y") {
    event.preventDefault();
    onRedo();
    return true;
  }

  if (event.key === "z" && !event.shiftKey) {
    event.preventDefault();
    onUndo();
    return true;
  }

  return false;
};

export const handleUndoRedo = (event, { onUndo, onRedo }, editor, isSlateEditor, isRatingDialogOpen) => {
  if (isSlateEditor && editor && editor.hasFocus) {
    return;
  }

  if (shouldSkipUndoRedoForDialog(event, isRatingDialogOpen)) {
    return;
  }

  if (handleMacUndoRedo(event, { onUndo, onRedo })) {
    return;
  }

  handleWindowsUndoRedo(event, { onUndo, onRedo });
}; 